import { DropdownItem } from '@gosuite/selects';

export interface AdvancedSearchformDistance {
	min: number;
	max: number;
}

export interface AdvancedSearchformDistances {
	beach: AdvancedSearchformDistance;
	busStation: AdvancedSearchformDistance;
	cityCenter: AdvancedSearchformDistance;
	restaurants: AdvancedSearchformDistance;
	river: AdvancedSearchformDistance;
	sea: AdvancedSearchformDistance;
	shopping: AdvancedSearchformDistance;
	skiArea: AdvancedSearchformDistance;
	trainStation: AdvancedSearchformDistance;
}

export interface HotelTypeAttributes {
	apartmentHotel: boolean;
	businessHotel: boolean;
	conferenceHotel: boolean;
	cityHotel: boolean;
	beachHotel: boolean;
	bungalowComplex: boolean;
	casinoResort: boolean;
	clubResort: boolean;
	adultsOnly: boolean;
	ecoHotel: boolean;
	familyHotel: boolean;
	finca: boolean;
	golfHotel: boolean;
	mountainHotel: boolean;
	mountainCottage: boolean;
	countryHouse: boolean;
	skiHotel: boolean;
	spaComplex: boolean;
	villageHotel: boolean;
	youthHostel: boolean;
}

export interface HotelFacilityAttributes {
	miniClub: boolean;
	laundromat: boolean;
	wlan: boolean;
	jacuzzi: boolean;
	steamBath: boolean;
	sunTerrace: boolean;
	sunLoungers: boolean;
	tanningSalon: boolean;
	sauna: boolean;
	medicalService: boolean;
	withSmokingArea: boolean;
	withoutSmokingArea: boolean;
	seaView: boolean;
}

export interface TransferAttributes {
	withTransfer: boolean;
	withoutTransfer: boolean;
	rentalCar: boolean;
}

export interface BeachAttributes {
	nearToBeach: boolean;
	parasols: boolean;
	pebbleBeach: boolean;
	stonyBeach: boolean;
	sandyBeach: boolean;
	sunLoungers: boolean;
}

export interface SportAttributes {
	aerobics: boolean;
	archery: boolean;
	badminton: boolean;
	basketball: boolean;
	beachVolleyball: boolean;
	bowling: boolean;
	darts: boolean;
	golf: boolean;
	gym: boolean;
	gymnastics: boolean;
	massages: boolean;
	miniGolf: boolean;
	mountainBike: boolean;
	squash: boolean;
	tableTennis: boolean;
	tennis: boolean;
	waterSports: boolean;
	childCare: boolean;
	entertainmentProgram: boolean;
}

export interface PoolAttributes {
	indoorPool: boolean;
	outdoorPool: boolean;
	saltWaterPool: boolean;
	childrenPool: boolean;
	heatedPool: boolean;
	freshOrColdWaterPool: boolean;
	poolBar: boolean;
}

export interface AdvancedSearchformModel {
	hotelChains: Array<DropdownItem>;
	hotelType: HotelTypeAttributes;
	hotelFacilities: HotelFacilityAttributes;
	beach: BeachAttributes;
	transfer: TransferAttributes;
	sport: SportAttributes;
	pool: PoolAttributes;
	distances: AdvancedSearchformDistances;
}

export const DEFAULT_ADVANCED_SEARCHFORM_DISTANCE: AdvancedSearchformDistance = {
	min: 0,
	max: 999999999999999
};

export const ADVANCED_SEARCHFORM_DEFAULT_VALUES: AdvancedSearchformModel = {
	hotelChains: [],
	hotelType: {
		apartmentHotel: false,
		businessHotel: false,
		conferenceHotel: false,
		cityHotel: false,
		beachHotel: false,
		bungalowComplex: false,
		casinoResort: false,
		adultsOnly: false,
		clubResort: false,
		ecoHotel: false,
		familyHotel: false,
		finca: false,
		golfHotel: false,
		mountainHotel: false,
		mountainCottage: false,
		countryHouse: false,
		skiHotel: false,
		spaComplex: false,
		villageHotel: false,
		youthHostel: false,
	},
	hotelFacilities: {
		miniClub: false,
		laundromat: false,
		wlan: false,
		jacuzzi: false,
		steamBath: false,
		sunTerrace: false,
		sunLoungers: false,
		tanningSalon: false,
		sauna: false,
		medicalService: false,
		withSmokingArea: false,
		withoutSmokingArea: false,
		seaView: false,
	},
	beach: {
		nearToBeach: false,
		parasols: false,
		pebbleBeach: false,
		stonyBeach: false,
		sandyBeach: false,
		sunLoungers: false,
	},
	transfer: {
		withTransfer: false,
		withoutTransfer: false,
		rentalCar: false,
	},
	sport: {
		aerobics: false,
		archery: false,
		badminton: false,
		basketball: false,
		beachVolleyball: false,
		bowling: false,
		darts: false,
		golf: false,
		gym: false,
		gymnastics: false,
		massages: false,
		miniGolf: false,
		mountainBike: false,
		squash: false,
		tableTennis: false,
		tennis: false,
		waterSports: false,
		childCare: false,
		entertainmentProgram: false,
	},
	pool: {
		indoorPool: false,
		outdoorPool: false,
		saltWaterPool: false,
		childrenPool: false,
		heatedPool: false,
		freshOrColdWaterPool: false,
		poolBar: false,
	},
	distances: {
		beach: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		busStation: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		cityCenter: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		restaurants: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		river: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		sea: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		shopping: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		skiArea: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
		trainStation: DEFAULT_ADVANCED_SEARCHFORM_DISTANCE,
	}
};



// WEBPACK FOOTER //
// ./src/app/xena/core/searchform/advanced-search-dialog/shared/advanced-searchform.model.ts